export default __webpack_public_path__ + "static/media/red-lighten-seasonal.d3416e8d.svg";